// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__P1le3","titleWrapper":"modal_titleWrapper__7iBUH","icon":"modal_icon__AxZxC"};